import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EqualValidator, MaskManager, UtilHelper } from '../../../shared';
import { DadosAcessoCidadao } from '../shared/dados-acesso-cidadao';
import { CadastroSenhaCidadaoService } from '../../../shared/service/cadastro-senha-cidadao.service';
import { ConsumidorFormatter } from '../shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbpOnlyConfirmComponent } from '../../../shared/modal/nbp-only-confirm.component';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';

@Component({
  selector: 'app-consumidor-cadastrar-senha-externo',
  templateUrl: './consumidor-cadastrar-senha-externo.component.html',
  styleUrls: []
})
export class ConsumidorCadastrarSenhaExternoComponent implements OnInit{

    public cadastrarSenhaForm: FormGroup;
    public mensagemErro: string = "";
    public maskData = MaskManager.DATA;
    public msgErroCadastroSenha: string;

    public _validationMessages = {
        'senha': {
          'required': 'O Campo Nova Senha é de preenchimento obrigatório.',
          'minlength': UtilHelper.MsgGenericas.senha_minlength,
          'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
        },
        'confirmarSenha': {
          'required': 'O Campo Confirmar Nova Senha é de preenchimento obrigatório.',
          'minlength': UtilHelper.MsgGenericas.senha_minlength,
          'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
        }
    };

    public _formErrors = {
    'senha': [],
    'confirmarSenha': []
    };

    public get formErrors() {
    return this._formErrors;
  }

  public get validationMessages() {
    return this._validationMessages;
  }

  public onValueChanged(data?: any): void {

    for (const campo in this.formErrors) {
      const control = this.cadastrarSenhaForm.get(campo);
      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          if (messages[key]) {
            this.formErrors[campo].push(messages[key]);
          }
        }
      }
    }
  }

    constructor(private readonly ngbModalService: NgbModal,
                private readonly cadastroSenhaCidadaoService: CadastroSenhaCidadaoService,
                private readonly router: Router
    ){}

    ngOnInit(): void {
        this.cadastrarSenhaForm = new FormGroup({
            'nomeMae': new FormControl(null, [Validators.required]),
            'dataNascimento': new FormControl(null, [Validators.required]),
            'senha': new FormControl(null, [Validators.required, Validators.minLength(6), EqualValidator.validaIgualdade.bind(this)]),
            'confirmarSenha': new FormControl(null, [Validators.required, Validators.minLength(6), EqualValidator.validaIgualdade.bind(this)])
        });

        this.cadastrarSenhaForm.valueChanges.subscribe(data => this.onValueChanged(data));
    }

    LimparErros(event) { 
    this.mensagemErro = "";
    }

    onSubmit() {
      var cpf: string = sessionStorage.getItem('cpfConsumidor');
      var dadosCidadao = new DadosAcessoCidadao();
      dadosCidadao.CpfBase = Number(cpf.substring(0,9));
      dadosCidadao.CpfDigito = Number(cpf.substring(9,11));
      dadosCidadao.NomeMae = this.cadastrarSenhaForm.get('nomeMae').value;
      dadosCidadao.DataNascimento = ConsumidorFormatter.strDateWithoutHourAndSlash(this.cadastrarSenhaForm.get('dataNascimento').value);
      dadosCidadao.Senha = btoa(this.cadastrarSenhaForm.get('senha').value);

      this.cadastroSenhaCidadaoService.cadastrarSenha(dadosCidadao)
      .subscribe((data: any) => {
        const modalRef = this.ngbModalService.open(NbpOnlyConfirmComponent, { size: 'lg' });
        var mensagem: string = data;
        modalRef.componentInstance.mensagem = mensagem.replace(/"/g, '');
        modalRef.componentInstance.userConfirmChange.subscribe((userConfirm) => {
          if(userConfirm) {
            this.router.navigate(['/consumidor']);
          }
        });
      }, (error: any) => {
              let err = error as StatusRequisicao; 
              this.msgErroCadastroSenha = err.motivo;
      });
    }
}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cadastrar-senha-externo/consumidor-cadastrar-senha-externo.component.ts